import { makeRequest } from '../../utils';

function makePostRequest(url, updatedFormData, handleUpdate) {
  const requestArgs = {
    method: 'POST',
    body: JSON.stringify(updatedFormData)
  };
  const contentType = 'application/json';
  makeRequest(url, requestArgs, contentType)
    .then((data) => {
      handleUpdate();
    })
    .catch((e) => console.error(e));
}

export function saveProcessing(
  systemID,
  contactData,
  processing,
  restProcessingChange
) {
  const updatedFormData = {
    system_id: systemID,
    system_type: processing['Type of System'],
    firm_nfhl: processing['FIRM/NFHL Symbol'],
    alignment_crest: processing['Alignment on Levee Crest'],
    new_features: processing['Added New Features'],
    alignment_closure: processing['Alignment has Closure'],
    alignment_floodwall: processing['Alignment has Floodwall'],
    alignment_road: processing['Alignment has Road'],
    alignment_railroad: processing['Alignment has Railroad'],
    alignment_high_ground: processing['Alignment has High Ground'],
    alignment_bridge: processing['Alignment has Bridge (CA style)'],
    alignment_orientation: processing['Alignment Lines Upstream to Downstream'],
    alignment_direction_consistent:
      processing['Alignment Lines in Same Direction'],
    transect_direction_consistent: processing['Transects in Same Direction'],
    alignment_snapped:
      processing['No Break between Two Connecting Alignment Lines'],
    transect_idx: processing['Transects have idx Values'],
    transect_cross: processing['Transects Cross'],
    area_dem_extent: processing['Leveed Area at DEM Extent'],
    area_special_case: processing['Leveed Area Special Case'],
    area_method: processing['Best Leveed Area Method'],
    area_snapped: processing['Leveed Area Snapped to Alignment'],
    maxel_centerline: processing['MaxEl Points on Levee Centerline'],
    alignment_updated: processing['Alignment Updated'],
    area_updated: processing['Leveed Area Updated'],
    report_run: processing['Report Run'],
    notes: processing['Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/processing',
    updatedFormData,
    restProcessingChange
  );
}

export function saveDetailedQC(
  systemID,
  contactData,
  detailedQC,
  restDetailedQCChange
) {
  const updatedFormData = {
    system_id: systemID,
    processing_metadata: detailedQC['Processing Metadata'],
    alignment_location: detailedQC['Alignment Location'],
    alignment_height: detailedQC['Alignment Height'],
    alignment_type: detailedQC['Alignment Type'],
    protection_captured: detailedQC['Entire Length of Protection Captured'],
    floodwalls_closures: detailedQC['Floodwalls/Closures'],
    notes: detailedQC['Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/detailed_qc',
    updatedFormData,
    restDetailedQCChange
  );
}

export function saveGeospatialQC(
  systemID,
  contactData,
  geospatialQC,
  restGeospatialQCChange
) {
  const updatedFormData = {
    system_id: systemID,
    alignment_orientation: geospatialQC['Alignment Orientation'],
    alignment_snapped:
      geospatialQC['No Break between Two Connecting Alignment Lines'],
    alignment_elev_units: geospatialQC['Alignment Elevation Units'],
    polygon_valid: geospatialQC['Polygon Valid'],
    polygon_vertices: geospatialQC['Polygon Vertices'],
    polygon_holes_removed: geospatialQC['Majority of Interior Holes Removed'],
    notes: geospatialQC['Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/geospatial_qc',
    updatedFormData,
    restGeospatialQCChange
  );
}

export function saveReasonablenessQC(
  systemID,
  contactData,
  reasonablenessQC,
  restReasonablenessQCChange
) {
  const updatedFormData = {
    system_id: systemID,
    system_type: reasonablenessQC['Type of System'],
    area_method: reasonablenessQC['Leveed Area Method'],
    elev_source: reasonablenessQC['Elevation Source'],
    elev_year: parseInt(reasonablenessQC['Elevation Date'], 10) || -9999,
    gpkg_complete: reasonablenessQC['Geopackage Complete'],
    transects_complete: reasonablenessQC['Transect with Toes Complete'],
    alignment_acceptable: reasonablenessQC['Alignment Acceptable'],
    alignment_cartography: reasonablenessQC['Alignment Cartography'],
    area_acceptable: reasonablenessQC['Leveed Area Acceptable'],
    dem_acceptable: reasonablenessQC['DEM Acceptable'],
    orthoimage_acceptable: reasonablenessQC['Orthoimage Acceptable'],
    usace_recommendation: reasonablenessQC['USACE Recommendation'],
    notes: reasonablenessQC['Final Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/reasonableness_qc',
    updatedFormData,
    restReasonablenessQCChange
  );
}

export function saveUSACEQC(systemID, contactData, usaceQC, restUSACEQCChange) {
  const updatedFormData = {
    system_id: systemID,
    notes: usaceQC['Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest('/nld_tracker/usace_qc', updatedFormData, restUSACEQCChange);
}

export function saveUSACEActions(
  systemID,
  contactData,
  usaceActions,
  restUSACEActionsChange
) {
  const updatedFormData = {
    system_id: systemID,
    system_type_change: usaceActions['System Type Change'],
    updated_system_type: usaceActions['Updated System Type'],
    dba_alerted: usaceActions['DBA Alerted'],
    geometry_updated: usaceActions['Geometry Updated'],
    geometry_submitted: usaceActions['Geometry Submitted'],
    nld_field_update: usaceActions['NLD Field Updated'],
    fouo_field_populated: usaceActions['FOUO Field Populated'],
    notes: usaceActions['Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/usace_actions',
    updatedFormData,
    restUSACEActionsChange
  );
}
//--------------------START streamline postData functions--------------------
export function saveInitialQC(
  systemID,
  contactData,
  initialQC,
  restInitialQCChange
) {
  const {
    'Type of System': system_type,
    'Alignment Adjustments': alignment_adjustments,
    Notes: notes
  } = initialQC;

  const updatedFormData = {
    system_id: systemID,
    system_type,
    alignment_adjustments,
    notes,
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/initial_qc',
    updatedFormData,
    restInitialQCChange
  );
}
export function saveInitialAnalyst(
  systemID,
  contactData,
  initialAnalyst,
  restInitialAnalystChange
) {
  const {
    'FIRM/NFHL Symbol': firm_nfhl,
    'Alignment Elevation Units': alignment_elev_units,
    'Alignment has Closure': alignment_closure,
    'Alignment has Floodwall': alignment_floodwall,
    'Alignment has Road': alignment_road,
    'Alignment has Railroad': alignment_railroad,
    'Alignment has High Ground': alignment_high_ground,
    'Alignment has Bridge (CA style)': alignment_bridge,
    'Best Leveed Area Method': area_method,
    Notes: notes,
    'Elevation Source': elev_source,
    'Elevation Date': elev_year
  } = initialAnalyst;

  const updatedFormData = {
    system_id: systemID,
    firm_nfhl,
    alignment_elev_units,
    alignment_closure,
    alignment_floodwall,
    alignment_road,
    alignment_railroad,
    alignment_high_ground,
    alignment_bridge,
    area_method,
    notes,
    elev_source,
    elev_year: parseInt(elev_year, 10) || -9999,
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/initial_analyst',
    updatedFormData,
    restInitialAnalystChange
  );
}
export function saveFinalQC(systemID, contactData, finalQC, restFinalQCChange) {
  const {
    'Type of System': system_type,
    'Alignment Acceptable': alignment_acceptable,
    'Leveed Area Acceptable': area_acceptable,
    'USACE Recommendation': usace_recommendation,
    'Final Notes': notes
  } = finalQC;
  const updatedFormData = {
    system_id: systemID,
    system_type,
    alignment_acceptable,
    area_acceptable,
    usace_recommendation,
    notes,
    contact_id: contactData['contactID']
  };
  makePostRequest('/nld_tracker/final_qc', updatedFormData, restFinalQCChange);
}
//--------------------END streamline postData functions--------------------
export function saveParkingLot(
  systemID,
  contactData,
  parkingLot,
  restParkingLotChange
) {
  const updatedFormData = {
    system_id: systemID,
    reason: parkingLot['Reason'],
    notes: parkingLot['Notes'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/parking_lot',
    updatedFormData,
    restParkingLotChange
  );
}

export function deleteParkingLot(systemID, restParkingLotChange) {
  const requestArgs = {
    method: 'DELETE'
  };
  const contentType = 'application/json';
  makeRequest(
    '/nld_tracker/delete_parking_lot?system_id=' + systemID,
    requestArgs,
    contentType
  )
    .then((data) => {
      restParkingLotChange();
    })
    .catch((e) => console.error(e));
}

export function saveSystemStatus(
  systemID,
  contactData,
  status,
  handleRequestMetadata
) {
  const updatedFormData = {
    system_id: systemID,
    overall_status: status['Status'],
    detailed_status: status['Detailed Status'],
    contact_id: contactData['contactID']
  };
  makePostRequest(
    '/nld_tracker/system_status',
    updatedFormData,
    handleRequestMetadata
  );
}

export function formatDateString(date) {
  // output as Day-Month-Year
  let datePart = date.toISOString().split('T')[0];
  return datePart.split('-').reverse().join('-');
}
